// @flow
import * as types from "../ACTIONS/commonActionTypes";
import initialState from './commonInitialState';
import Profile from "../SUPPORT/Profile";

export default function profilesReducer(state = initialState.profiles, ourClientId:number, action) {

    switch (action.type) {

        case types.GOT_PROFILES_LIST: {
            return ({
                initialized: true, items: convertJsonProfilesToProfileObjects(action.profiles)
            });
        }
        case types.GOT_CURRENT_PROFILESET: {  // if the profileset is changed, the profiles are changed to match
            const newState = {...state};
            newState.initialized = true;
            newState.items = convertJsonProfilesToProfileObjects(action.profileSet?.profiles);
            return (newState);
        }
        default:
            return state;
    }
}

/**
 * Convert the generic profile objects to Profile objects
 * @param profiles
 * @returns {*}
 */
export function convertJsonProfilesToProfileObjects(profiles:[]) {
    return profiles?.map((profile) => {
        const newProfile = new Profile();
        newProfile.FromJson(profile);
        return newProfile;
    });
}
    